// import Main from './Main'
import ListaReboquistas from './components/ListaReboquistas'

export default [
  // { path: '/reboquistas', component: Main, name: 'reboquistas.main' },
  {path: '/reboquistas/lista', component: ListaReboquistas, name: 'reboquistas.lista'}
]
